module.exports = __webpack_public_path__ + "img/edit.b83406bb.png";